import styled from "@emotion/styled"

const ArticleAsideFinalText = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  font-size: 18px;
  font-weight: 400;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-right: auto;
  margin-left: auto;
`

export default ArticleAsideFinalText
